export default __webpack_public_path__ + "static/media/enter-answer-fitb.6b74ff99.gif";